import { render, staticRenderFns } from "./index.vue?vue&type=template&id=83560dc8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/my-transaction/_my-transaction.scss?vue&type=style&index=0&id=83560dc8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83560dc8",
  null
  
)

export default component.exports